var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('cursor-fx',{attrs:{"color":"#00e2aa"}}),_c('Navbar'),_c('transition',{staticClass:"transition",attrs:{"name":_vm.transitionName}},[_c('router-view',{staticClass:"child-view"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }